// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"410":"973481cf","849":"7d6b4509","907":"db8aca58","977":"0a54c0ce"}[chunkId] + ".chunk.js";
};